<template>
	<loader v-if="loading || loadingSeriesAndVolumes" height="80vh" />
	<div v-else class="container ar">
		<breadcrumbs
			class="ar"
			:links="[
				{ name: $t('links.home'), link: '/' },
				{ name: $t('links.publisher'), link: { name: 'editorial-board' } },
				{ name: publisher.name, link: {}, active: true },
			]"></breadcrumbs>
		<div class="top d-flex flex-column justify-content-center align-items-center">
			<img
				class="publisher-image"
				:src="publisher.image ? publisher.image : '/assets/Icons/user.png'" />
			<h1 class="title d-flex flex-column align-items-center">
				{{ publisher.name }}
				<span class="details fs-4 mt-1" v-if="publisher.type">
					(
					{{
						publisher.type === 'عضو هيئة تحرير'
							? $t('publisher.editorial')
							: publisher.type === 'باحث'
							? $t('publisher.researcher')
							: $t('publisher.judge')
					}}
					<span
						class="details"
						v-if="isHasValue(publisher.type) && publisher.type === 'عضو هيئة تحرير'">
						في
						{{
							getSerieById(publisher.series[0]) ? getSerieById(publisher.series[0]).name : null
						}}
					</span>
					)
				</span>
			</h1>
			<div class="details" v-if="publisher.description">
				{{ publisher.description }}
			</div>
			<div>
				<span class="details" v-if="isHasValue(publisher.university)">
					{{ publisher.university }} -
				</span>
				<span class="details" v-if="isHasValue(publisher.college)"> {{ publisher.college }} - </span>
				<span class="details" v-if="isHasValue(publisher.section)">
					{{ publisher.section }}
				</span>
			</div>
			<span
				class="details"
				v-if="isHasValue(publisher.type) && publisher.type !== 'باحث' && isHasValue(publisher.rank)">
				{{ publisher.rank }}
			</span>
			<span class="details" v-if="isHasValue(publisher.status)">
				{{ publisher.status }}
			</span>

			<div class="writen-by align-self-start">{{ $t('publisher.help') }} {{ publisher.name }}</div>
		</div>
		<div class="main" v-if="publisherArticles.length > 0">
			<div v-for="article in publisherArticles" :key="article">
				<router-link
					:to="{
						name: 'article',
						params: {
							id: article.id,
							name: article.name,
							serieId: article.Series_ids[0],
							serieName: getSerie(article.Series_ids[0]).name.replaceSpace(),
							volumeId: article.Volumes_ids[0],
							volumeName: getVolume(article.Volumes_ids[0]).name.replaceSpace(),
						},
					}">
					<div class="article">
						<div class="a-date" v-if="article.approved_Date">
							{{ $t('publisher.date') }}
							{{ momentRev(article.approved_Date).format('YYYY MMMM DD') }}
						</div>
						<div class="a-title">
							{{ article.name }}
						</div>
						<div class="a-name">
							<div v-for="(publisher, i) in backward(article.publishers_ids)" :key="i">
								<img
									:src="
										publisher.publisherName.image
											? publisher.publisherName.image
											: '/assets/Icons/user.png'
									"
									alt="" />
								{{ publisher.publisherName.name }}
								(
								{{ publisher.statusTitle.name }}
								)
							</div>
						</div>
					</div>
				</router-link>
			</div>
		</div>
		<div class="text-center fs-4 py-5" v-else>{{ $t('publisher.no-data') }}</div>
	</div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import Loader from '@/components/Loader';
import { momentRev } from '@/helpers';
import { mapState, mapGetters } from 'vuex';
export default {
	props: ['publisherId', 'loadingSeriesAndVolumes'],

	components: {
		Breadcrumbs,
		Loader,
	},

	data() {
		return {
			publisherArticles: null,
			loading: true,
		};
	},

	computed: {
		publisher() {
			return this.getPublisherById(this.publisherId);
		},

		...mapState({
			publishers: (state) => state.publishers.publishers,
			volumes: (state) => state.volumes.volumes,
		}),

		...mapGetters({
			getPublisherById: 'publishers/getPublisherById',
			getVolumeById: 'volumes/getVolumeById',
			getSerieById: 'series/getSerieById',
		}),
	},

	methods: {
		backward(arr) {
			return arr.map((e) => e).reverse();
		},
		getVolume(id) {
			return this.getVolumeById(id);
		},

		getSerie(id) {
			return this.getSerieById(id);
		},

		enteri(ele) {
			const list = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						ele.classList.add('start');
					}
				});
			});
			list.observe(ele);
		},

		isHasValue(value) {
			return Boolean(value && value.length > 0);
		},

		momentRev,
	},
	mounted() {
		Promise.all([
			this.$store.dispatch('publishers/fetchAll'),
			this.$store.dispatch('publishers/fetchById', { id: this.publisherId }).then((data) => {
				this.publisherArticles = data;
			}),
		]).finally(async () => {
			await (this.loading = false);
			document.querySelectorAll('.main > div').forEach((e) => {
				this.enteri(e);
			});
		});
		// this.$store.dispatch('volumes/fetchById', { id: this.volumeId })
		// .then((data) => {
		// 	this.volume = data;
		// })
		// .finally(async() => {
		// 	await (this.loading = false);
		// 	document.querySelectorAll('.main > div').forEach((e) => {
		// 		this.enteri(e);
		// 	});
		// })
	},
};
</script>

<style scoped>
.container {
	margin-top: 50px;
	overflow-x: hidden;
}
.container > * {
	margin: 0 50px;
}
.top {
	padding: 10px 0;
	border-bottom: 2px solid var(--borders-color);
}
.details {
	font-family: changeMedium;
}
.top > *:not(span, div) {
	padding: 10px;
}
.publisher-image {
	max-width: 100px;
}
.title {
	font-size: 36px;
	font-family: changeBold;
	color: var(--green-color);
	text-align: center;
	margin: 0;
}
.writen-by {
	margin-top: 1rem;
	font-family: changeBold;
	font-size: 1.2rem;
}
.main {
	padding: 20px 0 50px;
}
.main > div {
	border-bottom: 2px solid var(--borders-color);
	margin: 15px;
	padding: 30px 0;
	transform: translateX(50px);
	visibility: hidden;
	transition: 1000ms;
}
.main > div.start {
	transform: translateX(0);
	visibility: visible;
}
.main > div:last-child {
	border: none;
}
.article {
	border-radius: 5px;
}
.a-title {
	max-height: 60px;
	line-height: 30px;
	font-family: changeBold;
	margin: auto;
	font-size: 20px;
}
.a-name {
	font-size: 16px;
	line-height: 30px;
	font-family: changeMedium;
}
.a-name img {
	height: 20px;
	margin: 0 10px;
}
.a-date {
	color: grey;
	font-size: 12px;
	line-height: 30px;
}
@media only screen and (max-width: 992px) {
	.container > * {
		margin: 0 10px;
	}
	.serie {
		text-align: center;
	}
}
@media only screen and (max-width: 768px) {
	.main > div {
		margin: 0;
	}
	.a-date {
		font-size: 12px;
	}
	.a-title {
		font-size: 18px;
	}
	.a-name {
		font-size: 14px;
		font-family: change;
	}
	.serie * {
		font-size: 13px;
	}
	.title {
		font-size: 30px;
	}
	.a-title {
		max-height: none;
	}
}
</style>
